import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface FavoriteStore {
  userFavorites: any | null;
  setUserFavorites: (favorites: any | null) => void;
}

export const useFavoriteStore = create<FavoriteStore>()(
  devtools(set => ({
    userFavorites: null,
    setUserFavorites: favorites => {
      if (favorites) {
        // Filter out deactivated line items
        const activeLineItems = favorites.lineItems?.filter(lineItem => !lineItem.deactivatedAt);
        favorites.lineItems = activeLineItems;
      }

      return set({ userFavorites: favorites });
    },
    enabled: true,
  })),
);
